/**
 * The 8 fixed coverage-combination labels used by the "Table Rates"
 * (rateStructureType = "table_rates") rate structure — one planRates row
 * per label, stored verbatim in the `coverage_table` column.
 *
 * Single source of truth — this exact list/order was previously duplicated
 * in PlanRates.tsx and enrollmentCalculator.ts.
 */
export const TABLE_RATE_LABELS = [
  "Employee",
  "Employee + Spouse",
  "Employee + 1 Children",
  "Employee + 2 Children",
  "Employee + 3+ Children",
  "Employee + 1 Children + Spouse",
  "Employee + 2 Children + Spouse",
  "Employee + 3+ Children + Spouse",
] as const;

export type TableRateLabel = (typeof TABLE_RATE_LABELS)[number];
